import { Button, Popconfirm } from "antd";
import { DeleteFilled, EditFilled, CheckCircleTwoTone, CloseCircleTwoTone, RollbackOutlined, UserSwitchOutlined } from "@ant-design/icons";

const propsColumnsAreasUser = (limitPagination) => {
    return {
        size: "large",
        bordered: true,
        pagination: {
            position: ["none", "none"],
            pageSize: limitPagination,
        },
        className: "cmsTable",
    };
};

const columnsType = (editAction, deleteAction, updateTeam) => {
    return [
        {
            title: "Estatus",
            dataIndex: "isActive",
            key: "isActive",
            width: 120,
            render: (_, record) => {
                const status = record.isActive;

                return (
                    <>
                        <span className="flex justify-center items-center text-2xl">
                            {status ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}
                        </span>
                    </>
                );
            },
            sorter: (a, b) => a.isActive - b.isActive,
        },
        {
            title: "Nombre",
            dataIndex: "name",
            key: "name",
            width: 240,
            render: (text) => <span>{text}</span>,
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
        },
        {
            title: "Equipo de proyecto",
            dataIndex: "canBeTeam",
            key: "canBeTeam",
            width: 160,
            render: (_, record) => {
                const canBeTeam = record.canBeTeam;
                return (
                    <>
                        <span className="flex justify-center items-center text-2xl">
                            {canBeTeam ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Color",
            dataIndex: "color",
            key: "color",
            width: 60,
            render: (_, record) => (
                <>
                    <div className={`w-6 h-6 rounded-full mx-auto`} style={{ backgroundColor: record.color }}></div>
                </>
            ),
        },
        {
            title: "Acciones",
            key: "action",
            render: (_, record) => {
                const status = record.isActive;
                const team = record.canBeTeam;
                return (
                    <div className="flex gap-2">
                        {status && (
                            <>
                                <Button
                                    type="text"
                                    icon={<EditFilled />}
                                    onClick={() => {
                                        editAction(record, record.key);
                                    }}
                                />
                                <Popconfirm
                                    title={`${!team ? "Hacer Team" : "No es team"}`}
                                    onConfirm={() => updateTeam(record.key, record.canBeTeam)}
                                >
                                    <Button type="text" icon={<UserSwitchOutlined />} />
                                </Popconfirm>
                            </>
                        )}
                        <Popconfirm title={`${status ? "¿Seguro eliminar?" : "¿Volver activar?"}`} onConfirm={() => deleteAction(record.key)}>
                            <Button type="text" icon={status ? <DeleteFilled /> : <RollbackOutlined />} />
                        </Popconfirm>
                    </div>
                );
            },
        },
    ];
};

export const columnsAreasUser = (editAction, deleteAction, limitPagination, updateTeam) => {
    const columns = columnsType(editAction, deleteAction, updateTeam);
    const props = propsColumnsAreasUser(limitPagination);
    return {
        columns,
        props,
    };
};
